import * as yup from 'yup';

import { REQUIRED } from '../forms/errorsText.js';
import MembershipSettingPresenter from '../presenters/MembershipSettingPresenter';

export const validationFields = {
  settingType: yup.string().required(REQUIRED),
  description: yup.string(),
  value: yup.number().required(REQUIRED),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (setting) => {
  return {
    settingType: MembershipSettingPresenter.settingType(setting) || '',
    description: MembershipSettingPresenter.description(setting) || '',
    value: MembershipSettingPresenter.value(setting) || '',
  };
};
